import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';
import { useContext, useEffect } from 'react';

import PacksList from '@/components/app/cards/PacksList';
import { PacksContext } from '@/components/app/layout/PacksProvider';
import Layout from '@/components/layout/LayoutWrapper';
import { usePacksClass } from '@/hooks/app/usePacksClass';
import { useRouterPush } from '@/hooks/utils/useRouterPush';
import { calmLogger } from '@/utils/calmLogger';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

const PacksClass = () => {
	const { query } = useRouter();
	const routerPush = useRouterPush();
	const packClassName = typeof query?.className === 'string' ? query.className : undefined;
	const { pack, isLoading } = usePacksClass(packClassName);
	const { setPageTitle } = useContext(PacksContext);

	useEffect(() => {
		setPageTitle(null);
	}, [pack, setPageTitle]);

	if (!pack && !isLoading) {
		routerPush('/404').catch(error =>
			calmLogger.error('Error in app PacksClass routerPush to /404', {}, error),
		);
		return null;
	}

	return (
		<Layout pageName={`pack-class-${packClassName}`}>
			<PacksList packs={pack ? [pack] : []} isLoading={isLoading} />
		</Layout>
	);
};

export default PacksClass;

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(context);

	return {
		props: {
			initialState: {
				...initialState,
				tags: [],
				theme: {
					webAppLayout: 'full',
				},
			},
		},
	};
};
